import { Component, type ReactNode } from 'react';
import { RotateCcw, AlertTriangle } from 'lucide-react';

// App-weites Sicherheitsnetz: faengt Render-Fehler JEDER Seite ab und zeigt einen
// freundlichen Recovery-Screen statt eines weissen Bildschirms. Die Shell (Sidebar)
// bleibt bedienbar, weil nur der Outlet-Inhalt hierin gewrappt ist.
// resetKey (= Route-Pfad) leert den Fehler automatisch beim Navigieren.

interface Props {
  children: ReactNode;
  resetKey?: string;
}
interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // Fuer spaeteres Reporting · vorerst nur Konsole.
    console.error('[AppErrorBoundary]', error, info);
  }

  componentDidUpdate(prev: Props) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex items-center justify-center min-h-[60vh] p-6">
        <div className="w-full max-w-md text-center bg-bg-surface/95 border border-border-primary rounded-2xl p-8 shadow-2xl">
          <div className="mx-auto w-12 h-12 rounded-full bg-danger/15 text-danger flex items-center justify-center mb-4">
            <AlertTriangle size={24} />
          </div>
          <h2 className="text-lg font-bold text-text-main mb-1.5">Etwas ist schiefgelaufen</h2>
          <p className="text-sm text-text-muted mb-6">
            Diese Ansicht konnte nicht geladen werden. Du kannst es erneut versuchen · deine anderen Bereiche
            sind nicht betroffen.
          </p>
          <div className="flex items-center gap-3">
            <button
              onClick={() => this.setState({ error: null })}
              className="flex-1 inline-flex items-center justify-center gap-2 py-2.5 rounded-xl bg-accent text-white text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              <RotateCcw size={15} /> Erneut versuchen
            </button>
            <button
              onClick={() => window.location.reload()}
              className="flex-1 py-2.5 rounded-xl border border-border-primary text-sm font-semibold text-text-muted hover:text-text-main hover:bg-bg-elevated transition-colors"
            >
              Neu laden
            </button>
          </div>
        </div>
      </div>
    );
  }
}
